import { TextField } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { type ChangeEvent, useCallback } from "react";

interface InputWithUnitProps {
  fieldId: string;
}

const InputWithUnit = (props: InputWithUnitProps) => {
  const { findFieldById, findCompositeFieldByName } = useFormData();
  const { dataTestIdPrefix } = useFormDataContext();

  const inputField = findFieldById(props.fieldId);
  const inputValue = inputField.value.asString();
  const value = inputValue.value() || inputValue.defaultValue();

  const unitField = findCompositeFieldByName(inputField, "unit");
  const unitValue = unitField.value.asString();
  const suffix = unitValue.value() || unitValue.defaultValue();

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      inputField.setValue(e.target.value);
    },
    [inputField],
  );

  const errorMessage = inputField.violations().join(", ");
  const customName = inputField.id();
  const writable = inputField.writable;

  const { translatorFor } = useFormDataContext();

  const translator = translatorFor(inputField);
  const label = translateField(translator, inputField, Suffix.LABEL);

  return (
    <TextField
      type='text'
      errorText={errorMessage || ""}
      helperText={""}
      isError={Boolean(errorMessage)}
      required={Boolean(inputField.required)}
      label={label.toString()}
      suffix={suffix}
      value={value}
      onChange={onChange}
      disabled={!writable}
      dataTestId={`${dataTestIdPrefix}-${customName}`}
    />
  );
};

export default InputWithUnit;
